window.DsmAdvertorial = (function () {
  function init(root, opts) {
    if (!root || root.__dsmInit) return;
    root.__dsmInit = true;

    var reveal = root.querySelector(opts.revealSelector);
    var offer = root.querySelector(opts.offerSelector);
    var sticky = root.querySelector('[data-dsm-sticky]');

    root.querySelectorAll('[data-dsm-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = root.querySelector(btn.getAttribute('data-dsm-scroll'));
        if (!target) return;
        var top = target.getBoundingClientRect().top + window.scrollY - 8;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    if (!sticky || !reveal || !offer) return;

    var btn = sticky.querySelector('[data-dsm-sticky-btn]');
    var titleEl = sticky.querySelector('.dsm-sticky__title');
    var subEl = sticky.querySelector('.dsm-sticky__sub');
    var revealed = false;

    function update() {
      var vh = window.innerHeight;
      var r = reveal.getBoundingClientRect();
      var o = offer.getBoundingClientRect();

      var nowRevealed = r.top < vh * 0.6;
      var overOffer = o.top < vh && o.bottom > vh * 0.35;

      if (nowRevealed !== revealed) {
        revealed = nowRevealed;
        titleEl.textContent = revealed ? sticky.dataset.titleAfter : sticky.dataset.titleBefore;
        subEl.textContent = revealed ? sticky.dataset.subAfter : sticky.dataset.subBefore;
        btn.textContent = revealed ? sticky.dataset.btnAfter : sticky.dataset.btnBefore;
        btn.setAttribute('data-dsm-scroll', revealed ? opts.offerSelector : opts.revealSelector);
      }
      sticky.hidden = overOffer;
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  return { init: init };
})();